import './bootstrap';
import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import {
    Layout,
    Pages,
    PollingProvider,
    InertiaPermissionProvider,
    TranslationEditorProvider
} from 'laravel-inertia-backend';
import './bootstrap';
import '../scss/app.scss';
import { LaravelReactI18nProvider } from 'laravel-react-i18n';
import {Image,Toast, ToastContainer} from "react-bootstrap";
import icons from './menuIcons.js';
import GlobalControls from "./Components/GlobalControls.jsx";
import { initNutzungserfassung } from './tracking/nutzungserfassung';
import { MenueZustandProvider } from './Components/Menue/MenueZustandContext.jsx';

createInertiaApp({
    resolve: name => {
        // 1. Lokale Seiten
        console.log(Pages);
        const localPages = import.meta.glob('./Pages/**/*.jsx', { eager: true });
        // 2. Seiten aus der Paketstruktur dynamisch auflösen
        // "Settings" hat hier bewusst eine lokale Ausnahme: Die Paket-Version
        // rendert Werte als natives <input>, das auf schmalen Fenstern nicht
        // umbrechen kann (Browser-Grenze, nicht per CSS lösbar) - die lokale
        // Seite unter ./Pages/Settings.jsx ersetzt nur diesen einen Namen,
        // alle anderen Seiten bleiben unverändert aus der Paketstruktur.
        let page = (name === 'Settings' && localPages['./Pages/Settings.jsx'])
            || Pages[name]
            || localPages[`./Pages/${name}.jsx`];

        console.log(page);
        if (!page) {
            throw new Error(`Seite "${name}" wurde weder lokal noch im laravel-inertia-backend gefunden!`);
        }

        // Einheitliche Behandlung von Modulen und Funktionen
        if (typeof page === 'function') {
            // `page` ist eine direkte Funktion (z. B. aus `Pages`)
            page = { default: page }; // Erzeuge manuell ein Modul-ähnliches Objekt
        }

        // 3. Layout hinzufügen, wenn nicht ausgeschlossen
        page.default.layout =
            name.startsWith('Auth/') || name === 'Welcome'
                ? undefined
                : (page) => (
                    <InertiaPermissionProvider>
                        <MenueZustandProvider>
                            <Layout
                                title="Molotow Ordermail 2"
                                menuIcons={icons}
                                titleElement={<><Image src="/images/logo_bg_dark.png" alt="ordermail 2" style={{ height: '1em' }} /><br/><span style={{fontSize:"12px", paddingLeft: '65px'}}>Ordermanagement</span></>}
                                children={<><GlobalControls/>{page}</>}
                                toastsActive={true}
                            />
                        </MenueZustandProvider>
                    </InertiaPermissionProvider>
                );

        return page;
    },
    setup({ el, App, props }) {
        createRoot(el).render(
            <LaravelReactI18nProvider
                locale={'de'}
                files={import.meta.glob('/resources/lang/*.json')}
            >
                <TranslationEditorProvider>
                <PollingProvider useJournal={true} interval={30000}>
                    <App {...props} />
                </PollingProvider>
                </TranslationEditorProvider>
            </LaravelReactI18nProvider>
        );

        // Startet nur, wenn der Server das Prop "activityTracking" auf true
        // setzt (siehe resources/js/tracking/nutzungserfassung.js) - sonst
        // passiert hier nichts.
        initNutzungserfassung();
    },
});
